@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';

@import '~@adv-mt/mt-markdown-wrapper/lib/index';
@import '~@adv-mt/mt-panel-basic/lib/index';

.mt-Static {
  min-height: 100vh;
}
